import * as React from 'react';

export default function (props) {
  return <div className="hidden" />;
}
